import { render, staticRenderFns } from "./menu-item-label.vue?vue&type=template&id=4ded3143"
import script from "./menu-item-label.vue?vue&type=script&lang=js"
export * from "./menu-item-label.vue?vue&type=script&lang=js"
import style0 from "./menu-item-label.vue?vue&type=style&index=0&id=4ded3143&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports